// extracted by mini-css-extract-plugin
export default {"container":"src-modules-registration-components-WelcomeModal-style__container_Dod19"};